"use strict";

var _regeneratorRuntime = require("/Users/arjunjain/Borderless/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _defineProperty = require("/Users/arjunjain/Borderless/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _asyncToGenerator = require("/Users/arjunjain/Borderless/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var constants_1 = require("./constants");

var utils_1 = require("./utils");

exports.apiMethod = function () {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (
    /*#__PURE__*/
    function () {
      var _apiHandler = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var _len,
            args,
            _key,
            _options$method,
            method,
            _options$path,
            path,
            _options$urlParams,
            urlParams,
            validator,
            _options$defaultData,
            defaultData,
            _options$retry,
            retry,
            data,
            resolvedURLObject,
            requestData,
            _args = arguments;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                for (_len = _args.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                  args[_key] = _args[_key];
                }

                _options$method = options.method, method = _options$method === void 0 ? constants_1.GET : _options$method, _options$path = options.path, path = _options$path === void 0 ? '' : _options$path, _options$urlParams = options.urlParams, urlParams = _options$urlParams === void 0 ? [] : _options$urlParams, validator = options.validator, _options$defaultData = options.defaultData, defaultData = _options$defaultData === void 0 ? {} : _options$defaultData, _options$retry = options.retry, retry = _options$retry === void 0 ? false : _options$retry;

                if (!(urlParams.length > 0 && args.length < urlParams.length)) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return", Promise.reject(new Error("This endpoint must be supplied with the following parameters: ".concat(urlParams.toString()))));

              case 4:
                data = Object.assign({}, defaultData, args.length > urlParams.length && typeof args[urlParams.length] === 'object' ? args[urlParams.length] : {});

                if (!validator) {
                  _context.next = 13;
                  break;
                }

                _context.prev = 6;
                validator(data);
                _context.next = 13;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](6);
                return _context.abrupt("return", Promise.reject(_context.t0));

              case 13:
                resolvedURLObject = urlParams.reduce(function (accumulator, param, i) {
                  var value = args[i];

                  if (typeof value !== 'string' && typeof value !== 'number') {
                    throw new Error('Parameter must be a string or a number');
                  }

                  return Object.assign({}, accumulator, _defineProperty({}, param, typeof value === 'number' ? value.toString() : value));
                }, {});
                requestData = {
                  headers: this.headers,
                  method: method,
                  url: utils_1.solveURLParams("".concat(this.resourcePath).concat(path), resolvedURLObject)
                };

                if (Object.keys(data).length > 0) {
                  if (method === constants_1.GET) {
                    requestData.url += "?".concat(utils_1.toQueryString(data));
                  } else {
                    requestData.data = data;
                  }
                }

                return _context.abrupt("return", this.request(requestData, retry));

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[6, 10]]);
      }));

      function apiHandler() {
        return _apiHandler.apply(this, arguments);
      }

      return apiHandler;
    }()
  );
};